module.exports = __webpack_public_path__ + "static/media/npc-female-4row.f8e4e6c1.png";